<app-table-view [fields]="fieldsDefinition" [data]="data" [recordTrackBy]="trackByGoodsItemNumber"
                (termUpdated)="term = $event" (addButtonClicked)="edit(null)"
                [editable]="editable" [rowClassFn]="goodsRowClassFn"></app-table-view>

<ng-template #placementsRef let-placements="value">
  @for (placement of placements; track placement.containerIdentificationNumber) {
    <div class="d-inline-flex placement-item px-2">
      <span class="sub-text me-2">
        <i class="fa fa-fw fa-light fa-xl fa-container-storage"></i>
      </span>
      <span
        class="d-inline-block text-truncate align-self-end cursor-pointer underline-tertiary link-underline-tertiary link-primary text-body"
        (click)="editEquipment(placement.containerIdentificationNumber)">
        <app-highlight [term]="term" [result]="placement.containerIdentificationNumber"></app-highlight>
      </span>
    </div>
  }
</ng-template>

<ng-template #goodsRef let-goods="value">
  <app-consignment-goods-column class="d-flex" [term]="term" [goods]="[goods]"
                                [onClick]="editGoodsItem"></app-consignment-goods-column>
</ng-template>

<ng-template #actionColumnRef let-record="value">
  <a class="btn rounded-circle p-1 text-primary h1 mb-0 action-btn" type="button" (click)="edit(record)">
    <i class="fa-fw fa-light fa-angle-right"></i>
  </a>
</ng-template>

<ng-template #houseConsignmentRef let-record="value">
  <app-consignment-house-column [houseConsignments]="record"
                                [consignmentProcessId]="consignmentProcess.consignmentProcessId"
                                [consignmentProcess]="consignmentProcess"></app-consignment-house-column>
</ng-template>
